import React, { useState, useContext } from 'react'
import PropTypes from 'prop-types'
import { CollapseContextProvider } from './context/collapseContext'
import classNames from 'classnames'
import { m, useReducedMotion } from 'framer-motion'
import MenuContext from './context/menuContext'
import { HiChevronDown } from 'react-icons/hi'

const MenuCollapse = props => {

	const { 
		children, 
		className,
		eventKey,
		expanded,
		label,
		onToggle,  
	} = props

	const { variant, sideCollapsed, defaultExpandedKeys } = useContext(MenuContext)
	const [ isExpanded, setIsExpanded ] = useState(() =>
		expanded || (Array.isArray(defaultExpandedKeys) && defaultExpandedKeys.includes(eventKey))
	)
	const reduceMotion = useReducedMotion()
	const expandedKeySignature = Array.isArray(defaultExpandedKeys) ? defaultExpandedKeys.join('\n') : ''
	const [menuSync, setMenuSync] = useState({ expanded, eventKey, expandedKeySignature })
	if (
		menuSync.expanded !== expanded ||
		menuSync.eventKey !== eventKey ||
		menuSync.expandedKeySignature !== expandedKeySignature
	) {
		setMenuSync({ expanded, eventKey, expandedKeySignature })
		if (Array.isArray(defaultExpandedKeys) && defaultExpandedKeys.includes(eventKey)) {
			setIsExpanded(true)
		}
		if (expanded !== isExpanded) {
			setIsExpanded(true)
		}
	}

	const toggleCollapse = e => {
        if (typeof onToggle === 'function') {
            onToggle(!isExpanded, e)
        }
		setIsExpanded(!isExpanded)
    }

	const menuCollapseItemClass = classNames(
		'menu-collapse-item',
		`menu-collapse-item-${variant}`,
		className,
	)

	return (
		<div className="menu-collapse" >
			<button type="button" className={classNames(menuCollapseItemClass, 'w-full border-0 bg-transparent text-left')} onClick={toggleCollapse}>
				<span className="flex items-center">{label}</span>
				<m.span 
					className="text-lg mt-1"
					initial={{ transform: 'rotate(0deg)' }} 
					animate={{ 
						transform: isExpanded ? 'rotate(-180deg)' : 'rotate(0deg)',
					}}
					transition={reduceMotion ? { duration: 0 } : { duration: 0.15 }}
				>
					{sideCollapsed ? null : <HiChevronDown /> }
				</m.span>
			</button>
			<CollapseContextProvider value={isExpanded}>
				<div
					className="ml-5"
					style={{
						display: 'grid',
						gridTemplateRows: isExpanded ? '1fr' : '0fr',
						transition: reduceMotion ? 'none' : 'grid-template-rows 150ms ease, opacity 150ms ease',
					}}
				>
					<ul style={{ overflow: 'hidden', opacity: isExpanded ? 1 : 0, margin: 0 }}>
						{children}
					</ul>
				</div>
			</CollapseContextProvider>
		</div>
	)
}

MenuCollapse.propTypes = {
	expanded: PropTypes.bool,
	onToggle: PropTypes.func,
	label: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.node
	]),
	children: PropTypes.node,
	className: PropTypes.string
}

MenuCollapse.defaultProps = {
	expanded: false,
	label: null
}

export default MenuCollapse
